'use client';
import { useState, useEffect } from 'react';
import { IoPersonSharp } from 'react-icons/io5';

import { memberDisplayNameToProfileSlug } from './memberProfileSlug';
import { SidebarRow, type SidebarRowTone } from '../../../app/(site)/government-trades/_components/SidebarRow';

interface TraderRowProps {
  chamber?: string;
  display_name: string;
  headshot: string;
  party: string;
  state: string;
  ttm_overall_return?: number;
  total_trades?: number;
  ttm_return?: number;
  type?: string;
}

export const TraderRow: React.FC<TraderRowProps> = ({
  chamber,
  display_name,
  headshot,
  party,
  state,
  total_trades,
  ttm_overall_return,
  ttm_return = 0,
  type = '',
}) => {
  const parsedName = memberDisplayNameToProfileSlug(display_name);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    if (!headshot || headshot.trim() === '') {
      setShowFallback(true);
      return;
    }

    const img = new Image();
    img.onload = () => setShowFallback(false);
    img.onerror = () => setShowFallback(true);
    img.src = headshot;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [headshot]);

  const isTopPerformer = typeof ttm_overall_return === 'number';
  const pct = isTopPerformer ? (ttm_overall_return as number) : ttm_return;
  const tone: SidebarRowTone =
    type === 'gainer' ? 'pos' : type === 'loser' ? 'neg' : pct >= 0 ? 'pos' : 'neg';
  const value = `${type === 'gainer' ? '+' : ''}${(pct * 100).toFixed(2)}%`;

  return (
    <SidebarRow
      uppercaseTitle
      uppercaseSubtitle
      party={party}
      href={`/government-trades/members/${parsedName}`}
      linkTitleOnly
      media={
        showFallback ? (
          <IoPersonSharp />
        ) : (
          <img alt={`${display_name} headshot`} src={headshot} onError={() => setShowFallback(true)} />
        )
      }
      title={display_name}
      subtitle={`${chamber} (${party}-${state})`}
      value={value}
      valueTone={tone}
      subValue={isTopPerformer ? undefined : `Trades: ${total_trades}`}
    />
  );
};
